import React, { useEffect, useMemo } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useFlightOfferUi } from "../../../contexts/FlightOfferUiContext";
import { peekMainFlightSearchEditorRequest } from "../../../features/searchOffer/searchOfferEditSearchHandshake";
import { isAgentFlightResultsListUrl } from "../flightBookingPathUtils";
import { useBookingFlow } from "./hooks/useBookingFlow";

/**
 * מסנכרן "מצב תוצאות" בזרימת טיסות: אחרי שלב חיפוש מוסתרת שורת החיפוש החיצונית
 * ב־PriceOffer (העורך נשאר ב־FlightResultsTopBar). ההדר העליון של הסוכן נשאר תמיד גלוי.
 *
 * חובה לכבד גם את כתובת ‎/flights/results‎ — אחרת אפקט ב־PriceOffer מפעיל immersive ואילו כאן
 * currentStep==="search" מחזיר false ודורס, ואז מוצג קומפקט חיצוני בעוד תוכן הוויזארד מוסתר (display:none).
 */
export default function FlightResultsImmersiveBridge() {
  const { pathname } = useLocation();
  const { flightStep: routeFlightStep } = useParams();
  const { currentStep } = useBookingFlow();
  const { setImmersiveFlightResults } = useFlightOfferUi();

  const pathForcedImmersive = useMemo(() => {
    const p = pathname || "";
    return (
      isAgentFlightResultsListUrl(p, routeFlightStep) ||
      p.includes("/packages/results") ||
      p.includes("/organized-tours/results") ||
      p.includes("/tour/results") ||
      (typeof window !== "undefined" &&
        ((window.location.pathname || "").includes("/packages/results") ||
          (window.location.pathname || "").includes("/organized-tours/results") ||
          (window.location.pathname || "").includes("/tour/results")))
    );
  }, [pathname, routeFlightStep]);

  useEffect(() => {
    if (peekMainFlightSearchEditorRequest()) {
      setImmersiveFlightResults(false);
      return;
    }
    if (pathForcedImmersive) {
      setImmersiveFlightResults(true);
      return;
    }
    setImmersiveFlightResults(currentStep !== "search");
  }, [pathForcedImmersive, currentStep, setImmersiveFlightResults]);

  useEffect(() => {
    return () => setImmersiveFlightResults(false);
  }, [setImmersiveFlightResults]);

  return null;
}
